var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52298 0C1.6123 0 0.0634766 1.59493 0.0634766 3.5625V15.1406C0.0634766 17.2721 1.74145 19 3.81127 19H19.379C21.4489 19 23.1268 17.2721 23.1268 15.1406V5.9375C23.1268 5.28164 22.6106 4.75 21.9737 4.75H20.8205V1.1875C20.8205 0.531644 20.3042 0 19.6673 0H3.52298ZM3.52298 2.375H18.5142V4.75H3.52298C2.88609 4.75 2.36981 4.21836 2.36981 3.5625C2.36981 2.90664 2.88609 2.375 3.52298 2.375ZM3.52298 7.125H20.8205V15.1406C20.8205 15.9605 20.1751 16.625 19.379 16.625H3.81127C3.01513 16.625 2.36981 15.9605 2.36981 15.1406L2.3765 6.91612C2.3765 6.91612 2.78934 7.12868 3.52298 7.125ZM17.361 10.6875C16.7241 10.6875 16.2078 11.2191 16.2078 11.875C16.2078 12.5309 16.7241 13.0625 17.361 13.0625C17.9979 13.0625 18.5142 12.5309 18.5142 11.875C18.5142 11.2191 17.9979 10.6875 17.361 10.6875Z",
    fill: "#2A343D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/Income.61c5290a8b48e34426074a378ed6209a.svg";
export { ForwardRef as ReactComponent };